import { useBookingRecoilValue } from "@/shared/client";
import { Box, Image } from "@chakra-ui/react";
import { keyframes } from "@emotion/react";

const rotate = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;
export const ReservationCircleButton = () => {
    const bookingURL = useBookingRecoilValue();

    const onLink = (url: string) => {
        if (bookingURL.includes("http")) {
            window.open(url, "_blank");
        }
        if (!bookingURL.includes("http")) {
            window.open(`https://${url}`, "_blank");
        }
    };
    return (
        <Box
            position="relative"
            w="90px"
            h="90px"
            display="flex"
            alignItems="center"
            justifyContent="center"
            cursor="pointer"
            onClick={() => onLink(bookingURL)}
        >
            <Image
                position="absolute"
                w="100%"
                h="100%"
                src={`${process.env.PUBLIC_URL}/assets/icons/circleReserve.png`}
                animation={`${rotate} 8s linear infinite`}
                backgroundSize="cover"
            />
            <Image
                w="36px"
                h="36px"
                src={`${process.env.PUBLIC_URL}/assets/icons/calendar.png`}
                backgroundSize="cover"
            />
        </Box>
    );
};
